export default
{
    path: "/ykbhome",
    component: () => import('../view/ykb/ykbhome.vue'),
    props: (route) => ({
        token:route.query.token,
        userId:route.query.userId,
        sapId:route.query.sapId,
        secondLoginType:route.query.secondLoginType,
        secondAssessToken:route.query.secondAssessToken,
        deviceId:route.query.deviceId,
    })
}



// WEBPACK FOOTER //
// ./src/router/ykbHomeRouter.js